import { Box, Button, Container, Typography } from "@mui/material";
import BreadCrumbs from "../../components/Breadcrumbs";
import StyledTitleDot from "../../components/common/StyledTitleDot";
import AirportImg from "../../assets/images/additional-services/airport.jpg";
import CleaningImg from "../../assets/images/additional-services/cleaning.jpg";
import LaundryServiceImg from "../../assets/images/additional-services/laundry_service.jpg";
import StorageServiceImg from "../../assets/images/additional-services/storage_service.jpg";
import KayakImg from "../../assets/images/additional-services/flight-ticket.png";
import MaskImg from "../../assets/images/additional-services/mask.svg";
import Mask2Img from "../../assets/images/additional-services/mask-2.svg";
import Mask3Img from "../../assets/images/additional-services/mask-3.png";
import { htmlParser } from "../../common/utils";
import LanguageCertImg from "../../assets/images/additional-services/languageCert.jpg";
import { useTranslation } from "react-i18next";

function MaskedImg({ serviceType }) {
  return (
    <>
      <Box
        sx={{
          width: "320px",
          maskImage: `url(${Mask3Img})`,
          maskSize: "100%",
          maskRepeat: "no-repeat",
        }}
      >
        <Box
          sx={{
            boxSizing: "border-box",
            display: "inline-block",
            overflow: "hidden",
            width: "initial",
            margin: "0px",
            padding: "0px",
            height: "initial",
            position: "relative",
            maxWidth: "100%",
          }}
        >
          <span
            style={{
              boxSizing: "border-box",
              display: "block",
              width: "initial",
              height: "initial",
              background: "none",
              opacity: "1",
              border: "0px solid",
              margin: "0px",
              padding: "0px",
              maxWidth: "100%",
              visibility: "hidden",
            }}
          >
            <img
              src={Mask2Img}
              style={{
                display: "block",
                maxWidth: "100%",
                width: "initial",
                height: "initial",
                background: "none",
                opacity: "1",
                border: "0px solid",
                margin: "0px",
                padding: "0px",
              }}
            />
          </span>
          <img
            src={serviceType}
            alt=""
            style={{
              borderRadius: "2rem",
              opacity: "1",
              zIndex: "2",
              position: "absolute",
              inset: "0px",
              padding: "0px",
              margin: "auto",
              display: "block",
              width: "0px",
              height: "0px",
              minWidth: "100%",
              maxWidth: "100%",
              minHeight: "100%",
              maxHeight: "100%",
              objectFit: "cover",
              left: "10px",
              top: "20px",
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          position: "absolute",
          inset: "0",
          top: "18px",
          width: "270px",
          left: "14px",
        }}
      >
        <img src={MaskImg} width={"100%"} height={"auto"} alt="" />
      </Box>
    </>
  );
}
export default function AdditionalServices() {
  const { t } = useTranslation();

  return (
    <>
      <Typography textTransform={"capitalize"} className="title" variant="h4">
        {t("additional-services.categories")}
        <StyledTitleDot />
      </Typography>
      <BreadCrumbs routs={[t("services")]} />

      <Container sx={{ marginTop: "2rem" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            marginBottom: "4rem",
            marginTop: "2rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              order: { xs: "2", md: "1" },
            }}
          >
            <Typography textTransform={"capitalize"} sx={{ fontSize: "24px" }}>
              {t("additional-services.flight.title")}
            </Typography>
            <Typography sx={{ fontSize: "16px" }}>
              {t("additional-services.flight.description")}
            </Typography>
            <Button
              target="_blank"
              href="https://www.kayak.co.uk/?utm_source=tradetracker&utm_medium=affiliate&utm_campaign=472424&utm_content=32925"
              sx={{
                marginTop: { xs: "1.5rem", md: "1.5rem", textTransform: 'capitalize' },
                width: { xs: "100%", md: "200px" },
              }}
              variant="contained"
              color="primary"
            >
              {t("view")}
            </Button>
          </Box>
          <Box
            sx={{
              marginLeft: { xs: "0", md: "2rem" },
              order: { xs: "1", md: "2" },
              position: "relative",
            }}
          >
            <MaskedImg serviceType={KayakImg} />
          </Box>
        </Box>

        <Box
          sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}
        >
          <Box
            sx={{ position: "relative", marginRight: { xs: "0", md: "2rem" } }}
          >
            <MaskedImg serviceType={AirportImg} />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography textTransform={"capitalize"} sx={{ fontSize: "24px" }}>
              {t("additional-services.airport.title")}
            </Typography>
            <Typography textTransform={"capitalize"} sx={{ fontSize: "16px" }}>
              {t("additional-services.airport.description")}
            </Typography>
            <Button
              href="/additional-services/airport"
              sx={{
                marginTop: { xs: "1.5rem", md: "1.5rem", textTransform: 'capitalize' },
                width: { xs: "100%", md: "200px" },
              }}
              variant="contained"
              color="primary"
            >
              {t("view")}
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            marginTop: "4rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              order: { xs: "2", md: "1" },
            }}
          >
            <Typography textTransform={"capitalize"} sx={{ fontSize: "24px" }}>
              {t("additional-services.cleaning.title")}
            </Typography>
            <Typography sx={{ fontSize: "16px" }}>
              {t("additional-services.cleaning.description")}
            </Typography>
            <Button
              href="/additional-services/cleaning-services"
              sx={{
                marginTop: { xs: "1.5rem", md: "1.5rem", textTransform: 'capitalize' },
                width: { xs: "100%", md: "200px" },
              }}
              variant="contained"
              color="primary"
            >
              {t("view")}
            </Button>
          </Box>
          <Box
            sx={{
              marginLeft: { xs: "0", md: "2rem" },
              order: { xs: "1", md: "2" },
              position: "relative",
            }}
          >
            <MaskedImg serviceType={CleaningImg} />
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            marginTop: "4rem",
          }}
        >
          <Box sx={{ marginRight: "2rem", position: "relative" }}>
            <MaskedImg serviceType={LanguageCertImg} />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography sx={{ fontSize: "24px" }}>
              {t("additional-services.languagecert.title")}
            </Typography>
            <Typography sx={{ fontSize: "16px" }}>
              {htmlParser(
                t("additional-services.languagecert.description")
              )}
            </Typography>
            <Button
              href="https://www.languagecert.org/en/language-exams/english/languagecert-academic/academic"
              target="_blank"
              sx={{
                marginTop: { xs: "1.5rem", md: "1.5rem", textTransform: 'capitalize' },
                width: { xs: "100%", md: "200px" },
              }}
              variant="contained"
              color="primary"
            >
              {t("view")}
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            marginTop: "4rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              order: { xs: "2", md: "1" },
            }}
          >
            <Typography textTransform={"capitalize"} sx={{ fontSize: "24px" }}>
              {t("additional-services.storage.title")}
            </Typography>
            <Typography sx={{ fontSize: "16px" }}>
              {t("additional-services.storage.description")}
            </Typography>
            <Button
              disabled
              href="#"
              sx={{
                marginTop: { xs: "1.5rem", md: "1.rem", textTransform: 'capitalize' },
                width: { xs: "100%", md: "200px" },
              }}
              variant="contained"
              color="primary"
            >
              {t("view")}
            </Button>
          </Box>
          <Box
            sx={{
              marginLeft: { xs: "0", md: "2rem" },
              order: { xs: "1", md: "2" },
              position: "relative",
            }}
          >
            <MaskedImg serviceType={StorageServiceImg} />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            marginTop: "4rem",
          }}
        >
          <Box sx={{ marginRight: "2rem", position: "relative" }}>
            <MaskedImg serviceType={LaundryServiceImg} />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography textTransform={"capitalize"} sx={{ fontSize: "24px" }}>
              {t("additional-services.laundry.title")}
            </Typography>
            <Typography sx={{ fontSize: "16px" }}>
              {t("additional-services.laundry.description")}
            </Typography>
            <Button
              disabled
              href="#"
              sx={{
                marginTop: { xs: "1.5rem", md: "1.5rem", textTransform: 'capitalize' },
                width: { xs: "100%", md: "200px" },
              }}
              variant="contained"
              color="primary"
            >
              {t("view")}
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
}
